import OrderStatus from "@/types/orderStatus.js";

export default {
  data() {
    return {
      orderTypes: OrderStatus
    }
  },

  methods: {
    isComplete(order) {
      return order.status === OrderStatus.Complete;
    },
    isDraft(order) {
      return order.status === OrderStatus.Draft;
    },
    isPending(order) {
      return order.status === OrderStatus.Pending;
    },

    orderStatus(status) {
      const texts = {
        [OrderStatus.QuoteRequested]: "Quote Requested",
        [OrderStatus.QuoteSubmitted]: "Quote Submitted",
        [OrderStatus.Pending]: "Pending",
        [OrderStatus.Processing]: "Processing",
        [OrderStatus.Complete]: "Complete",
        [OrderStatus.Draft]: "Draft",
        default: status,
      };

      return texts[status] || texts["default"];
    },

    orderStatusClass(status) {
      const classes = {
        [OrderStatus.QuoteRequested]: "kt-badge--danger",
        [OrderStatus.QuoteSubmitted]: "kt-badge--info",
        [OrderStatus.Pending]: "kt-badge--dark",
        [OrderStatus.Processing]: "kt-badge--warning",
        [OrderStatus.Complete]: "kt-badge--success",
        default: "kt-badge--elevate",
      };

      return classes[status] || classes["default"];
    },
  },
};
